export const corpList = [
  {
    name: "디프다제주",
    ceo: "변수빈",
    email: "kkongsb@gmail.com",
    region: "제주",
  },
  {
    name: "봉그젠",
    ceo: "한성영",
    email: "-",
    region: "제주",
  },
  {
    name: "쓰담속초",
    ceo: "정미현",
    email: "-",
    region: "동해",
  },
  {
    name: "쓰줍인",
    ceo: "박현지",
    email: "-",
    region: "동해",
  },
  {
    name: "에코팀",
    ceo: "박한규",
    email: "-",
    region: "서해",
  },
  {
    name: "오션케어",
    ceo: "임선영",
    email: "-",
    region: "제주",
  },
  {
    name: "유명인해양청소봉사단",
    ceo: "김재열",
    email: "founder@covo.kr",
    region: "동해",
  },
  {
    name: "지구별약수터",
    ceo: "이경아",
    email: "lka911449@hanmail.net",
    region: "제주",
  },
  {
    name: "클린낚시운동본부",
    ceo: "권은정",
    email: "give@bf.or.kr",
    region: "동해",
  },
  {
    name: "팀부스터",
    ceo: "곽태진",
    email: "teambooster2020@gmail.com",
    region: "동해",
  },
  {
    name: "프로젝트퀘스천",
    ceo: "최은원",
    email: "-",
    region: "서해",
  },
  {
    name: "플로깅울릉",
    ceo: "정대웅",
    email: "nvc1365@hanmail.net",
    region: "동해",
  },
  {
    name: "플로빙코리아",
    ceo: "전장원",
    email: "-",
    region: "제주",
  },
  {
    name: "해양환경보호단 레디",
    ceo: "이유나",
    email: "-",
    region: "서해",
  },
  {
    name: "혼디",
    ceo: "김효식",
    email: "memo31313@naver.com",
    region: "제주",
  },
  {
    name: "환경운동연합",
    ceo: "노진철, 강찬수, 차수철",
    email: "web@kfem.or.kr",
    region: "서해",
  },
  {
    name: "휴먼인러브",
    ceo: "이희국",
    email: "-",
    region: "서해",
  },
  {
    name: "바다키퍼",
    ceo: "조수경",
    email: "-",
    region: "명예",
  },
  {
    name: "제주바당",
    ceo: "강호영",
    email: "jeju_badang@naver.com",
    region: "명예",
  },
  {
    name: "다시해봄",
    ceo: "-",
    email: "-",
    region: "명예",
  },
];
